// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { CSSObject } from 'styled-components'

export interface SizeProps {
  minWidth?: string | number;
  width?: string | number;
  maxWidth?: string | number;
  minHeight?: string | number;
  height?: string | number;
  maxHeight?: string | number;
}

export default ({ minWidth, width, maxWidth, minHeight, height, maxHeight }: SizeProps) => {
  const style: CSSObject = {};

  if (minWidth) {
    style.minWidth = typeof minWidth === 'number' ? `${minWidth}px` : minWidth;
  }

  if (width) {
    style.width = typeof width === 'number' ? `${width}px` : width;
  }

  if (maxWidth) {
    style.maxWidth = typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth;
  }

  if (minHeight) {
    style.minHeight = typeof minHeight === 'number' ? `${minHeight}px` : minHeight;
  }

  if (height) {
    style.height = typeof height === 'number' ? `${height}px` : height;
  }

  if (maxHeight) {
    style.maxHeight = typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight;
  }

  return style;
}
